import request from '../config/axios-config'

// 通过code获取openId
export function getOpenId(code){
  return request({
    url: `/api/blade-food/parent/regiestUserForOfficial?code=${code}`
  })
}
// 查找省市区
export function proviceList(){
  return request({
    url:'/api/blade-food/parent/region-tree',
    method: 'get'
  })
}
// 根据省市区查找学校
export function findSchool(code,tenantName){
  return request({
    url:`/api/blade-food/parent/getSchoolByCode?areaCode=${code}&tenantName=${tenantName}`,
    method: 'get'
  })
}
// 学校绑定
export function bindSchool(data){
  return request({
    url: '/api/blade-food/appUserTenant/bind',
    method: 'post',
    data
  })
}
// 通过openID获取绑定学校列表
export function bindSchoolList(openId){
  return request({
    url:`/api/blade-food/appUserTenant/getTenantList?openId=${openId}`,
    method: 'get'
  })
}
// 获取学校公示食谱
export function recipeList(tenantId){
  return request({
    url: `/api/blade-food/recipe/page?size=99999&current=1&ascs=id&searchType=2&recipeName=&isUse=&isPub=0&isBoard=1&createTimeStr=&createTimeStrEnd=&tenantId=${tenantId}`,
    method: 'get'
  })
}
// 通过食谱id获取评分
export function score(id,tenantId){
  return request({
    url: `/api/blade-food/parent/calRecipeById?recipeId=${id}&tenateId=${tenantId}`,
    method: 'get',
  })
}
// 通过食谱id获取食谱详情
export function recipeDetail(id){
  return request({
    url: `/api/blade-food/recipe/recipeDetail?id=${id}`,
    method: 'get'
  })
}
// 获取评论详情
export function commentDetail(data){
  return request({
    url: '/api/blade-food/recipecomment/hasComment',
    method: 'get',
    params:{
      recipeId:data.recipeId,
      openId:data.openId
    }
  })
}
// 通过时间,学校id获取食谱列表
export function recipeListByTime(data){
  return request({
    url: '/api/blade-food/recipe/recipeDetailByWeek',
    method: 'get',
    params: data
  })
}

export function nutritonDetail(data){
	return request({
		url: '/api/blade-food/recipe/calRecipe',
		method: 'POST',
		data
	})
}